import { Box } from '@mui/material'
import React, { Children, type ReactNode } from 'react'

interface CenteredCardLayoutProps {
  children: ReactNode[] | ReactNode
  addPadding?: boolean
}

const CenteredCardLayout: React.FunctionComponent<CenteredCardLayoutProps> = ({ children, addPadding }) => {
  const childrenArray = Children.toArray(children)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: (addPadding === true) ? 4 : 0,
      }}
    >
      {childrenArray}
    </Box>
  )
}

export default CenteredCardLayout
